<div [formGroup]="formGroup">
    <sc-flex wrap>
        <sc-number-field grow labelDictionaryKey="tmc-yard.access.ui.entrance-leave-dialog.weight" formControlName="weight"></sc-number-field>
        <sc-content-spacer></sc-content-spacer>
        <ng-container *ngIf="autoWeighingSource != null">
          <sc-action-icon iconClass="fa-balance-scale fa-2x" (click)="readWeight()"></sc-action-icon>
          <sc-content-spacer></sc-content-spacer>
        </ng-container>
        <sc-select-field grow labelDictionaryKey="tmc-yard.access.ui.entrance-leave-dialog.weighing-usage" formControlName="weightUsage" [data]="options" val></sc-select-field>
      <sc-hint-legacy *ngIf="maxWeightExceeded()" class="weighingError" [dictionaryKey]="'tmc-yard.access.ui.entrance-leave-dialog.weight-exceeded-error'" [type]="'error'"></sc-hint-legacy>
    </sc-flex>
</div>
